"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _AlertingBanner = require("./AlertingBanner.style");
var _getAppConfig = _interopRequireDefault(require("../../constants/getAppConfig"));
var _fetchLinkForResetPassword = _interopRequireDefault(require("../../utils/fetchLinkForResetPassword"));
var _AlertingBannerModal = _interopRequireDefault(require("../Modals/AlertingBannerModal"));
const AlertingBanner = _ref => {
  var _bannerContent$textBa2, _bannerContent$button, _bannerContent$closeB, _bannerContent$textBa3, _bannerContent$textBa4, _modalContents$modalT, _modalContents, _modalContents$modalT2, _modalContents$modalB, _modalContents2, _modalContents2$modal, _modalContents3;
  let {
    ModalComp,
    isMobile,
    banner,
    locale
  } = _ref;
  const {
    bannerContent,
    modalContent
  } = banner;
  const {
    CHG_PWD_MODAL: changePasswordModalContent,
    FIND_OUT_MORE_MODAL: findoutMoreModalContent
  } = modalContent || {};
  const [isChangePasswordModalOpen, setPasswordChangeModalOpen] = (0, _react.useState)(false);
  const [isFindOutModalOpen, setFindOutModalOpen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    var _bannerContent$textBa;
    if (!(bannerContent !== null && bannerContent !== void 0 && (_bannerContent$textBa = bannerContent.textBanner) !== null && _bannerContent$textBa !== void 0 && _bannerContent$textBa[locale])) return;
    const appRoot = document.querySelector('#icis-app-root');
    if (appRoot && appRoot instanceof HTMLElement) {
      appRoot.style.height = '104px';
    }

    // eslint-disable-next-line
    return () => {
      if (appRoot && appRoot instanceof HTMLElement) {
        appRoot.style.height = '';
      }
    };
  }, [bannerContent, locale]);
  if (!(bannerContent !== null && bannerContent !== void 0 && (_bannerContent$textBa2 = bannerContent.textBanner) !== null && _bannerContent$textBa2 !== void 0 && _bannerContent$textBa2[locale])) {
    return null;
  }
  const getLinkForResetPassword = async () => {
    try {
      const {
        bff: bffUrl
      } = (0, _getAppConfig.default)().urls;
      const linkFetch = (0, _fetchLinkForResetPassword.default)({
        bffUrl
      });
      const fetchedLink = await linkFetch;
      return fetchedLink;
    } catch (e) {
      return null;
    }
  };
  const handleOpenModal = button => {
    if (button.isPrimary) setPasswordChangeModalOpen(true);else setFindOutModalOpen(true);
  };
  const handleCloseModal = () => {
    if (isChangePasswordModalOpen) setPasswordChangeModalOpen(false);
    if (isFindOutModalOpen) setFindOutModalOpen(false);
  };
  const getFooterButtons = buttons => buttons.filter(button => button.isDisplayed).map(button => (button === null || button === void 0 ? void 0 : button.text[locale]) || '');
  const handleOnContinue = async () => {
    const ticket = await getLinkForResetPassword();
    if (ticket) {
      window.open(ticket, '_self');
    }
    handleCloseModal();
  };
  const handleBannerClose = () => {
    const appRoot = document.querySelector('#icis-app-root');
    if (appRoot && appRoot instanceof HTMLElement) {
      appRoot.style.height = '';
    }
  };
  let modalContents = null;
  if (isChangePasswordModalOpen) {
    modalContents = changePasswordModalContent;
  } else if (isFindOutModalOpen) {
    modalContents = findoutMoreModalContent;
  }
  const actionButtons = bannerContent !== null && bannerContent !== void 0 && (_bannerContent$button = bannerContent.button) !== null && _bannerContent$button !== void 0 && _bannerContent$button.length ? bannerContent === null || bannerContent === void 0 ? void 0 : bannerContent.button.map((button, index) => {
    var _button$text, _button$text$locale;
    return button.isDisplayed ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      key: index,
      testId: "alerting-banner-button-".concat(button === null || button === void 0 ? void 0 : (_button$text = button.text) === null || _button$text === void 0 ? void 0 : _button$text.en),
      variant: button.isPrimary ? 'Tertiary' : 'AuthoringPrimary',
      onClick: () => handleOpenModal(button)
    }, (_button$text$locale = button.text[locale]) !== null && _button$text$locale !== void 0 ? _button$text$locale : '') : null;
  }) : null;
  return /*#__PURE__*/_react.default.createElement(_AlertingBanner.StyledBannerContainer, null, /*#__PURE__*/_react.default.createElement(_uiKit.Banner, {
    testId: "alerting-banner",
    hideCloseButton: !(bannerContent !== null && bannerContent !== void 0 && (_bannerContent$closeB = bannerContent.closeButton) !== null && _bannerContent$closeB !== void 0 && _bannerContent$closeB.isDisplayed),
    level: "Info",
    version: "V2",
    hideReloadButton: true,
    textPosition: "center",
    onClose: handleBannerClose
  }, /*#__PURE__*/_react.default.createElement(_AlertingBanner.StyledBanner, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_AlertingBanner.StyledText, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "triangle-exclamation",
    color: _uiKit.theme.colours.WHITE,
    size: "lg"
  }), (_bannerContent$textBa3 = bannerContent === null || bannerContent === void 0 ? void 0 : (_bannerContent$textBa4 = bannerContent.textBanner) === null || _bannerContent$textBa4 === void 0 ? void 0 : _bannerContent$textBa4[locale]) !== null && _bannerContent$textBa3 !== void 0 ? _bannerContent$textBa3 : ''), /*#__PURE__*/_react.default.createElement(_AlertingBanner.ButtonsWrapper, {
    isMobile: isMobile
  }, actionButtons)), isChangePasswordModalOpen || isFindOutModalOpen ? /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.default, {
    testId: isChangePasswordModalOpen ? 'alerting-chg-pwd-modal' : 'alerting-find-out-more-modal',
    title: (_modalContents$modalT = (_modalContents = modalContents) === null || _modalContents === void 0 ? void 0 : (_modalContents$modalT2 = _modalContents.modalTitle) === null || _modalContents$modalT2 === void 0 ? void 0 : _modalContents$modalT2[locale]) !== null && _modalContents$modalT !== void 0 ? _modalContents$modalT : '',
    bodyMessages: (_modalContents$modalB = (_modalContents2 = modalContents) === null || _modalContents2 === void 0 ? void 0 : (_modalContents2$modal = _modalContents2.modalBody) === null || _modalContents2$modal === void 0 ? void 0 : _modalContents2$modal[locale]) !== null && _modalContents$modalB !== void 0 ? _modalContents$modalB : [''],
    footerButtonsText: getFooterButtons(((_modalContents3 = modalContents) === null || _modalContents3 === void 0 ? void 0 : _modalContents3.buttons) || []),
    onClose: handleCloseModal,
    ModalComp: ModalComp,
    onContinue: handleOnContinue,
    shouldHideIcon: isFindOutModalOpen,
    isTextLeftAlign: isFindOutModalOpen
  }) : null));
};
var _default = exports.default = AlertingBanner;